// Utilitaire pour charger le fichier GPX par défaut au premier lancement
export async function loadDefaultGpxActivity(): Promise<string | null> {
  try {
    const response = await fetch('/paris-marathon.gpx');
    if (!response.ok) throw new Error('GPX file not found');
    return await response.text();
  } catch (e) {
    console.error('Failed to load default GPX:', e);
    return null;
  }
}
